export const BuildInfo = {timestamp:1775770873000}
